<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="I/we would like to make a tax-deductible donation of:">
                    <div>
                        <AmountSelectorList/>                    
                        <ErrorLabel field="amount" />
                    </div>
                    <div class="frequency__suport">
                    <PaymentOptions  addMonthly monthlyText="Monthly Supporter"/>
                    </div>
                    <InHonorOf /> 
                    <TransactionFee v-if="form.amount"/>
                </FormSection>
                <FormSection title="Personal Info">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>

                      	<div class="consent__field">
		<FormRow>
  		<input type="checkbox" id="consent" name="consent" @click="setValue('custom.consent', $event.target.checked)" />

      <FormLabel for="consent" class="label__consent">Opt in to SMS communications</FormLabel>
		</FormRow>
    <div v-if="getValue('custom.consent')">
  		<FormLabel for="consent" class="label__consent">By providing your telephone number and checking the box, you consent to receive calls and text messages.
Msg & data rates may apply. Msg frequency may vary. Messaging may include requests for donation.
Reply “STOP” to opt-out & “HELP” for help.
        <a href="https://advocacy.ou.org/privacy-policy/" target="_blank">View Privacy Policy</a> for more info.</FormLabel>
	</div>
	</div>
                  </FormRow>                    
                    <DonorAddress />                                        
                </FormSection>                
                <FormSection title="Payment Info" last>
            <div class="payment-info">
              <FormRow>
                <PaymentType cc_text="Payment Methods" check_text="Check" />
              </FormRow>
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              <FormRow
                v-if="form.gateway === 'check'"
                class="checktext"
              >
                <div class="checktext">
                  Kindly make the contribution payable to OU Advocacy, and/or write OU Advocacy in the memo, and mail to:
                  <p style="">
                    <strong
                      >OU Advocacy, Attention: Tia Anatian<br>
        40 Rector Street<br>
        4th Floor<br>
        New York, NY 10006</strong
                    >
                  </p>
                </div>
              </FormRow>
            </div>
          </FormSection>
                <PaymentButton showAmount btnText="Submit Donation"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { onMounted } from 'vue'
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { setValue, getValue, form, submit } = usePaymentForm()

    if (props.subCampaign) {
      setValue('applications.0.subCampaign', props.subCampaign)
    }

    onMounted(() => {
      const params = queryParams()

      if (params.utm_content) {
        if (
          !['Direct Mail', 'Telemarketing', 'Text SMS Message'].includes(
            params.utm_content
          )
        ) {
          throw new Error('Invalid subcampaign')
        }

        setValue('applications.0.subCampaign', params.utm_content)
      }
    })

    return {
      form,
      getValue,
      setValue,
      submit,
    }
  },
})
</script>
<style scoped lang="scss">

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}


::v-deep .radio-part {
  @media (min-width: 720px) {
    &:nth-child(3n) {
      padding-right: 0;
    }
  }
}

.donate__content{
  max-width: 900px;
  padding: 0px 20px;
  margin: 40px auto;
  line-height: 1.4;
  p{
    margin-bottom: 1rem;
  }
}
.checktext{
    text-align: left !important;
    justify-content: flex-start;
    line-height: 1.4;
}

::v-deep  .consent__field{
  	cursor: pointer;

input[type="checkbox"] {
	margin-right: 10px;
  max-width: 15px;
  margin-bottom: 0px;
  &.consent__input{
    margin-right: 0px;
    margin-left: 10px;
  }
}


::v-deep .form-group {
  display: flex;
}
}

 .label__consent{
  line-height: normal;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  font-size: 14px !important;
}
.label__consent a{
  text-decoration: underline;
  color: blue;
}

::v-deep .styled-radio-container.styled-radio-container--ou-donation.row{

 #amount_other {
    height: 43px;
    padding-left: 10px;
    margin-top: 0px;
}
.amount_other__wrapper.amount-row {
    margin: 0px 0px 26px;
}
   .amount_other__wrapper:after {
    content: none !important;
    
}
  .amount-row{
    min-width: 100%;
    max-width: 100%;

    label{
          align-items: center;
    padding: 0px;
    display: flex;
    justify-content: flex-start;
    overflow: hidden;
margin-top: 0px;
    margin-bottom: 0px;
    }
  }
  .label-amount{
        font-size: 15px;
  }
  span.label-description {
    display: flex;
    flex-flow: column;
    padding: 6px 10px 6px;
    text-align: left;
    align-items: flex-start;
    justify-content: flex-start;
          font-size: 16px;
          font-weight: bold;
          color: #183150;
        span{
    color: #000;
    font-size: 14px;
    display: block;
    padding-top: 3px;
    font-style: italic;
        }
}
input[type=radio]:checked + label{
    background: #183150;
    color: white;
      span.label-description {
  color: white;
        span{
         color: white;
        }
}
}
input[type=radio]:checked + label .label-amount {
    background: #1a559f;
    border-color: #1849ff;
}
}

::v-deep .frequency__suport{
  .styled-radio-container.styled-radio-container--ou-donation.row{
    flex-flow: row-reverse;
    justify-content: flex-end;
    .radio-part{
              max-width: 40%;
    }
  }
}
</style>

